// extracted by mini-css-extract-plugin
export default {"statsItem":"statistic-item_statsItem__3i2M5"};